import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SiteSettingsProvider } from "@/contexts/SiteSettingsContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import SEOHead from "@/components/SEOHead";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import TrackOrder from "@/pages/TrackOrder";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import CustomerDashboard from "@/pages/customer/Dashboard";
import OrderCheckout from "@/pages/customer/OrderCheckout";
import OrderDetail from "@/pages/customer/OrderDetail";
import Profile from "@/pages/customer/Profile";
import Orders from "@/pages/customer/Orders";
import Invoices from "@/pages/customer/Invoices";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminServices from "@/pages/admin/AdminServices";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminContent from "@/pages/admin/AdminContent";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Apply from "@/pages/Apply";
import ApplyRedirect from "@/pages/ApplyRedirect";
import ApplySuccess from "@/pages/ApplySuccess";
import StaticPage from "@/pages/StaticPage";
import CashfreeReturn from "@/pages/CashfreeReturn";
import Support from "@/pages/customer/Support";
import AdminTickets from "@/pages/admin/AdminTickets";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminReports from "@/pages/admin/AdminReports";
import NotFound from "@/pages/NotFound";
import AuthCallback from "@/pages/AuthCallback";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteSettingsProvider>
          <BrowserRouter>
            <ScrollToTop />
            <SEOHead />
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/service/:slug" element={<ServiceDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/apply" element={<ApplyRedirect />} />
            <Route path="/apply/:slug" element={<Apply />} />
            <Route path="/apply/success/:id" element={<ApplySuccess />} />
            <Route path="/pages/:slug" element={<StaticPage />} />
            <Route path="/payment/cashfree/return" element={<CashfreeReturn />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route path="/checkout/:slug" element={
              <ProtectedRoute><OrderCheckout /></ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute><CustomerDashboard /></ProtectedRoute>
            } />
            <Route path="/dashboard/orders" element={
              <ProtectedRoute><Orders /></ProtectedRoute>
            } />
            <Route path="/dashboard/orders/:id" element={
              <ProtectedRoute><OrderDetail /></ProtectedRoute>
            } />
            <Route path="/dashboard/invoices" element={
              <ProtectedRoute><Invoices /></ProtectedRoute>
            } />
            <Route path="/dashboard/profile" element={
              <ProtectedRoute><Profile /></ProtectedRoute>
            } />
            <Route path="/dashboard/support" element={
              <ProtectedRoute><Support /></ProtectedRoute>
            } />

            <Route path="/admin" element={
              <ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/admin/tickets" element={
              <ProtectedRoute adminOnly><AdminTickets /></ProtectedRoute>
            } />
            <Route path="/admin/coupons" element={
              <ProtectedRoute adminOnly><AdminCoupons /></ProtectedRoute>
            } />
            <Route path="/admin/reports" element={
              <ProtectedRoute adminOnly><AdminReports /></ProtectedRoute>
            } />
            <Route path="/admin/orders" element={
              <ProtectedRoute adminOnly><AdminOrders /></ProtectedRoute>
            } />
            <Route path="/admin/orders/:id" element={
              <ProtectedRoute adminOnly><AdminOrderDetail /></ProtectedRoute>
            } />
            <Route path="/admin/services" element={
              <ProtectedRoute adminOnly><AdminServices /></ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>
            } />
            <Route path="/admin/content" element={
              <ProtectedRoute adminOnly><AdminContent /></ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </SiteSettingsProvider>
      </AuthProvider>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
